import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { UserService } from 'app/services/user/user.service';
import { environment } from 'environments/environment';
import { LOOTBOX_ITEMS } from 'assets/json/items';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss'],
  encapsulation: ViewEncapsulation.None,
})



export class ReferralComponent implements OnInit {
  public items: any = LOOTBOX_ITEMS().filter((obj: any) => { return (obj.type !== 'battle_consumable' && obj.type !== 'lootbox' && obj.type !== 'unfreezing-potion') });
  // public account
  public refCode
  public friendsInvited
  public loyaltyBudget
  public filterValue
  public taloneProfileId
  public isLoading
  public shareUrl
  public isNew
  public taskCompleted: any = {}
  wallet: string;
  constructor(
    private toastService: ToastService,
    // private clipSrv: ClipboardService,
    private http: HttpClient,
    private userService: UserService
  ) {
    this.isLoading = false;
    this.isNew = false;
    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((item: any) => {
    //     this.account = item[0];
    //     this.getReferralCode();

    //   });
    // } else {
    //   this.account = this.appComponent.accounts[0];
    //   this.getReferralCode();

    // }
    this.wallet = this.userService._userInfoData.recordedWallet;
    this.getReferralCode();

    let accountCreated = this.getCookieValue("playfab-account-created");
    console.log('ah')
    console.log(accountCreated)
    if (accountCreated) {
      let date = new Date(accountCreated);
      let threshold = new Date("2023-01-27");
      if (date >= threshold) {
        this.isNew = true;
      } else {
        this.isNew = false;
      }
    }
    /*for(let i = 0; i<this.items.length;i++){
      this.itemsSelected.push(false)
    }*/
  }

  ngOnInit(): void { }

  getReferralCode() {
    let post = { wallet: this.wallet };
    this.http.post(environment.apiBaseUrl + "loyalty/getUserRefCode.php", post).subscribe((item: any) => {
      console.log(item)
      if (item.referrals !== undefined) {
        if (item.referrals.length > 0) {
          this.refCode = item.referrals[0].code;
          this.friendsInvited = item.referrals[0].usageCounter
          this.loyaltyBudget = item.loyalty.programs.kryptomon_loyalty_prod.ledger.currentBalance
          this.taloneProfileId = item.profile.id
          this.shareUrl = "https://kryptomon.co/genesis?ref=" + this.refCode;
          this.taskCompleted = item.profile.attributes;
        } else {
          this.generateReferralCode()
        }
      }
    })
  }

  copyRefCode() {
    console.log('copy');
    navigator.clipboard.writeText("https://kryptomon.co/genesis?ref=" + this.refCode).then(e => {
      this.toastService.add(
        {
          severity: 'success',
          summary: 'toastMessage.referralLinkCopied',
          detail: 'toastMessage.inviteFriends',
        });
    }).catch(e => console.error(e));

  }

  generateReferralCode() {
    let post = { wallet: this.wallet };
    this.http.post(environment.apiBaseUrl + "loyalty/generateReferral.php", post).subscribe((item: any) => {
      console.log(item)
      if (item.code != undefined) {
        setTimeout(() => {
          this.getReferralCode();
        }, 2500)
      }
    })
  }

  selectFilter(value) {
    this.filterValue = value;
  }

  redeemItem(itemId, index) {
    this.isLoading = true;
    this.items[index].selected = true;
    let playfabId = this.getCookieValue('playfab-id')
    let post = { wallet: this.wallet, itemId: itemId, playfabId: playfabId, profileId: this.taloneProfileId };
    console.log(post)
    this.http.post(environment.apiBaseUrl + "loyalty/buyItem.php", post).subscribe((item: any) => {
      if (item.status == 'done') {
        this.loyaltyBudget = item.payload.loyalty.programs.kryptomon_loyalty_prod.ledger.tentativeCurrentBalance
        this.isLoading = false;
        this.items[index].selected = false;
        this.items[index].success = true;
        setTimeout(() => {
          this.items[index].success = false;
        }, 3000)
      } else {
        console.log('error')
        console.log(item)
        this.toastService.genericError();
      }
    })
  }

  getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  }
}


